'use client'

import { useEffect } from 'react'
import { ApiUnavailablePage } from '@/General/ApiUnavailablePage'
import { reportClientError } from '@/lib/logging/clientErrorReporter'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
    reportClientError(error, 'global_error_boundary')
  }, [error])

  return (
    <html lang="en">
      <head>
        <title>Service unavailable | Vanishing Inc.</title>
        <meta name="robots" content="noindex" />
      </head>
      <body>
        <ApiUnavailablePage error={error} reset={reset} />
      </body>
    </html>
  )
}
